import type { IconData } from '@stacksjs/iconify-core'

export const basicUiDashboard: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M3 0a3 3 0 0 0-3 3v7h7V0zm4 12H0v1a3 3 0 0 0 3 3h4zM9 0h4a3 3 0 0 1 3 3v1H9zm7 6H9v10h4a3 3 0 0 0 3-3z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiDashboard
